"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  breakpoints: {
    keys: ['md', 'lg'],
    values: {
      md: 1024,
      lg: 1440
    }
  },
  direction: 'ltr',
  spaces: {
    0: 0,
    1: 4,
    2: 8,
    3: 12,
    4: 16,
    5: 20,
    6: 24,
    7: 28
  },
  palette: {
    primary: {
      100: '#E7EEFD',
      200: '#90B3F9',
      300: '#1D61F6',
      400: '#0A51EB'
    },
    light: {
      100: '#ffffff',
      200: '#F6F7F9',
      300: '#EDEFF3',
      400: '#E0E4E9'
    },
    dark: {
      100: '#F5F6F8',
      200: '#8092AD',
      300: '#3C495E',
      400: '#081B2D'
    },
    grey: {
      100: '#FAFAFA',
      200: '#F2F3F2',
      300: '#CACACA',
      400: '#AAAAAA',
      500: '#8A8A8A',
      600: '#6A6A6A',
      700: '#4A4A4A',
      800: '#2A2A2A',
      900: '#0A0A0A'
    },
    white: {
      100: '#AAAAAA',
      200: '#C9C9C9',
      300: '#DCDCDC',
      400: '#E2E2E2',
      500: '#ECECEC',
      600: '#F0F0F0',
      700: '#F3F3F3',
      800: '#F6F6F6',
      900: '#FFFFFF'
    },
    green: {
      100: '#EEFCF6',
      200: '#ABFBE1',
      300: '#69E4B4',
      400: '#26CF8E',
      500: '#26CF8E'
    },
    red: {
      100: '#FCEEEE',
      200: '#FACDCD',
      300: '#D45D5D',
      400: '#CC4141',
      500: '#CC4141'
    },
    orange: {
      100: '#FDF1E6',
      200: '#F7C99F',
      300: '#ED7B30',
      400: '#E16614',
      500: '#E16614'
    },
    blue: {
      100: '#E7EEFD',
      200: '#90B3F9',
      300: '#1D61F6',
      400: '#0A51EB',
      500: '#0A51EB'
    },
    yellow: {
      100: '#FEF7E7',
      200: '#FCEFD0',
      300: '#F9D277',
      400: '#F6BB47',
      500: '#F6BB47'
    }
  },
  shadows: {
    up: '0px -12px 24px rgba(10, 10, 10, 0.04)',
    down: '0px 12px 24px rgba(10, 10, 10, 0.04)',
    aroundLow: '-4px 4px 20px rgba(10, 10, 10, 0.04), 4px -4px 20px rgba(10, 10, 10, 0.04)',
    aroundHigh: '-4px 4px 28px 4px rgba(10, 10, 10, 0.04), 4px -4px 28px 4px rgba(10, 10, 10, 0.04)'
  },
  typography: {
    baseFontSize: 16,
    baseFontFamily: 'Inter, sans-serif',
    h1: {
      fontSize: '32px',
      lineHeight: '48px',
      fontWeight: 700
    },
    h2: {
      fontSize: '22px',
      lineHeight: '34px',
      fontWeight: 600
    },
    h3: {
      fontSize: '22px',
      lineHeight: '34px',
      fontWeight: 500
    },
    h4: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500
    },
    helperText: {
      fontSize: '12px',
      lineHeight: '16px',
      fontWeight: 400
    },
    body1: {
      fontSize: '18px',
      lineHeight: '26px',
      fontWeight: 600
    },
    body2: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 500
    },
    body3: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 400
    },
    body4: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400
    },
    body5: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 500
    },
    label1: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 700
    },
    label2: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: 600
    },
    label3: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 700
    },
    label4: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: 500
    },
    textAlign: {
      left: 'left',
      center: 'center',
      right: 'right'
    },
    fontWeight: {
      bold: 700,
      semiBold: 600,
      medium: 500,
      regular: 400,
      light: 300
    },
    fontDecoration: {
      normal: 'normal',
      underline: 'underline'
    },
    fontType: {
      heading: {
        XXL: {
          size: 56,
          lineHeight: 82
        },
        XL: {
          size: 56,
          lineHeight: 82
        },
        L: {
          size: 44,
          lineHeight: 64
        },
        M: {
          size: 32,
          lineHeight: 48
        },
        S: {
          size: 22,
          lineHeight: 34
        },
        XS: {
          size: 16,
          lineHeight: 22
        },
        XXS: {
          size: 16,
          lineHeight: 22
        },
        WCM: {
          size: 16,
          lineHeight: 22
        }
      },
      body: {
        XXL: {
          size: 24,
          lineHeight: 38
        },
        XL: {
          size: 20,
          lineHeight: 30
        },
        L: {
          size: 18,
          lineHeight: 26
        },
        M: {
          size: 16,
          lineHeight: 24
        },
        S: {
          size: 14,
          lineHeight: 22
        },
        XS: {
          size: 12,
          lineHeight: 20
        },
        XXS: {
          size: 10,
          lineHeight: 14
        },
        WCM: {
          size: 8,
          lineHeight: 12
        }
      }
    },
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontFamily: {
      regular: {
        fontWeight: 400
      },
      medium: {
        fontWeight: 500
      },
      semibold: {
        fontWeight: 600
      }
    },
    bodyXXSmall: {
      fontSize: '10px',
      lineHeight: '14px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    bodyXSmall: {
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    bodyXSmallMedium: {
      fontSize: '12px',
      lineHeight: '16px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 500
    },
    bodySmall: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    bodyRegular: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    bodyMedium: {
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 500
    },
    bodyLarge: {
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    headingXsmallMedium: {
      fontSize: '16px',
      lineHeight: '20px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 500
    },
    headingSmallMedium: {
      fontSize: '18px',
      lineHeight: '24px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 500
    },
    headingMedium: {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 500
    },
    headingRegular: {
      fontSize: '20px',
      lineHeight: '24px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 400
    },
    headingLargeSemiBold: {
      fontSize: '24px',
      lineHeight: '32px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 600
    },
    headingXLargeSemiBold: {
      fontSize: '30px',
      lineHeight: '36px',
      letterSpacing: '0px',
      margin: '0px',
      fontWeight: 600
    },
    placeholder: {
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 400
    }
  },
  borderRadius: {
    primary: 4,
    secondary: 24,
    tertiary: 8
  },
  transitions: {
    easing: {
      easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
      easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
      easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
      sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
    },
    duration: {
      shortest: 150,
      shorter: 200,
      "short": 250,
      standard: 300,
      complex: 375,
      enteringScreen: 225,
      leavingScreen: 195
    }
  },
  zIndex: {
    context: 800,
    hoverOver: 1000,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500,
    rail: 1600
  }
};
exports["default"] = _default;